import axios from 'axios';
import _ from 'lodash';

let cli = axios.create({
  baseURL: 'http://localhost:3000',
  timeout: 15 * 1000,
})

let foo = 'bar'

class Merchant {
  static async search(term) {
    if (!term){
      return []
    }

    // try 1
    let sql = `
select userid from profile where 1
and (
name like '%${term}%'
or nickname like '%${term}%'
or address like '%${term}%'
or businessaddr like '%${term}%'
or idnumber like '${term}%'
or userid = "${term}"
or telephone = "${term}"
or contact = "${term}"
or bankaccount = "${term}"
or brchbank_code = "${term}"
)
limit 20;
    `
    let { data: { data } } = await cli.post('/', {
      action: 'sql_query',
      database: 'qf_core',
      sql,
    })
    console.log('try1', {
      sql,
      data
    })

    if (!_.size(data)) {
      // try 2 - qtapp
      let sql = `
    select userid from qtapp where 1
    and (code = "${term}" or \`key\` = "${term}")
    limit 100;
        `
      let { data: { data: rs2 } } = await cli.post('/', {
        action: 'sql_query',
        database: 'qf_core',
        sql,
      })

      data = rs2
      console.log('try2', {
        sql, rs2
      })
    }

    // determine merchants and stores
    let useridsString = _.chain(data)
      .map(r => {
        return _.get(r, 'userid')
      })
      .join(", ")
      .value()
    sql = `
select * from user_relation where 1
and status = 1
and (userid in (${useridsString}))
-- and (userid in (${useridsString}) or link_id in (${useridsString}))
and link_cate = 'merchant' 
group by userid
limit 100;
    `
    let { data: { data: data2 } } = await cli.post('/', {
      action: 'sql_query',
      database: 'qf_user',
      sql,
    })
    console.log('--links', { data2, sql })

    let isPrecise = _.size(data2) === 1

    let stores = null
    let keys = null
    if (isPrecise) {
      sql = `
      select link_id from user_relation where 1
      and status = 1
      and (userid in (${_.first(data2).userid}))
      and link_cate = 'merchant' 
      limit 30;
          `
      let { data: { data: data3 } } = await cli.post('/', {
        action: 'sql_query',
        database: 'qf_user',
        sql,
      })

      stores = data3
      console.log('--stores', {
        sql,
        data3
      })
    }

    // collect report
    useridsString = _.chain(data2)
        .map(r => {
          return _.get(r, 'userid')
        })
        .join(", ")
        .value()
    sql = `select * from profile where userid in (${useridsString}) limit 100`
    let { data: { data: merchants } } = await cli.post('/', {
      action: 'sql_query',
      database: 'qf_core',
      sql,
    })
    console.log('--------merchants', {merchants, sql, useridsString})

    if (isPrecise) {
      let merchantId = data2[0].userid

      sql = `
  select * from user_relation
  where userid = "${merchantId}"
  and status = 1
  and link_cate = 'merchant' 
  limit 1000;
      `
      let { data: { data: tmp } } = await cli.post('/', {
        action: 'sql_query',
        database: 'qf_user',
        sql,
      })

      useridsString = _.chain(tmp)
        .map(r => {
          return _.get(r, 'link_id')
        })
        .join(", ")
        .value()
      sql = `select * from profile where userid in (${useridsString}) limit 1000`
      let { data: { data: tmp2 } } = await cli.post('/', {
        action: 'sql_query',
        database: 'qf_core',
        sql,
      })

      stores = tmp2
      // console.log(useridsString, tmp, sql, tmp2)

      tmp.push({ link_id: merchantId })
      useridsString = _.chain(tmp)
        .map(r => {
          return `"${_.get(r, 'link_id')}"`
        })
        .join(", ")
        .value()
      sql = `
    select * from qtapp where 1
    and userid in (${useridsString})
    limit 1000;
        `
      let { data: { data: tmp3 } } = await cli.post('/', {
        action: 'sql_query',
        database: 'qf_core',
        sql,
      })
      keys = tmp3
// console.log('--stores 2', {sql, useridsString})
    }

    // console.log(data2[0], data2[0].userid, sql)
    // console.log({ term, data, useridsString, data2 })

    return {
      term,
      isPrecise,
      merchants,
      stores,
      keys,
    }
  }
}

// let Merchant = {
//   async search(term) {

//   },
//   getGateway() {

//   },
//   getStore() {

//   }
// }

export default foo
export {
  Merchant,
}